import { useEffect } from 'react';
import reactGA4 from 'react-ga4';
import {
  ANALYTICS_DEBUGMODE,
  ANALYTICS_ENABLED,
  ANALYTICS_TESTMODE,
  ANALYTICS_TRACKINGID,
} from '../utils/analytics';

const options = {
  debug: ANALYTICS_DEBUGMODE,
  testMode: ANALYTICS_TESTMODE,
  titleCase: true,
};

export const useAnalyticsInitialize = () => {
  useEffect(() => {
    if (!ANALYTICS_ENABLED) {
      return;
    }

    reactGA4.initialize(ANALYTICS_TRACKINGID, options);
  }, []);
};
